module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-arrow-r-c987c90d3282a3e1aebfa9e8b9e865af.svg";